<template>
  	<div class="module_page page_content institution payment_plans add_coupon" aria-label="Institution Summary view content page">

    <div class="row page-heading">
      <div class="col-2 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
        <!-- <label class="head_txt module_type_name institution-title ace_sec_hd"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{institution.title}}</label>
        <label class="head_txt module_type_name ace_sec_hd" v-if="showEntity"> <span class="separator">::</span> {{entity.title}}</label> -->
      </div>
      <div class="col-10 right-container">

        <template v-if="!showLoader">
          <template v-if="!showEditProgramAssignment && !showEditPricingPlanAssignment">
            <template v-if="isPaymentGatewayEnabled">
              <template v-if="!paymentGateway.setupComplete">
                <div class="row pg_hd">
                  <div class="col-6 hd">
                    <div class="ace_sec_txt hd_txt">Coupons</div>
                    <div class="ace_sec_txt hd_info">Click on the 'connect' button to integrate with Stripe</div>
                  </div>
                  <div class="col-6 btn_container">
                    <b-link class="btn" aria-label="connect" :href="stripeConnectLink">connect</b-link>
                  </div>
                </div>
              </template>
              <template v-if="paymentGateway.setupComplete">
                <div class="row pg_hd">
                  <div class="col-6 hd">
                    <div class="ace_sec_txt hd_txt">Coupons</div>
                  </div>
                  <div class="col-6 btn_container">
                    <b-btn class="btn" @click="openNewCouponCodeModal()">add coupon</b-btn>
                    <b-btn class="btn" @click="returnToEcommerce()">back to e-commerce</b-btn>
                  </div>
                </div>
              </template>
            </template>
          </template>

          <template v-if="showEditProgramAssignment || showEditPricingPlanAssignment">
            <!-- assign plan header -->
            <div class="row pg_hd">
              <div class="col-6 hd">
                <div class="ace_sec_txt hd_txt">Assign {{selectedCouponCode.name}} to Program</div>
                <div class="ace_sec_txt hd_info">
                </div>
              </div>
              <div class="col-6 btn_container">
                <a href="javascript:void(0)" class="btn" @click="saveUpdateAssignment">save</a>
              </div>
            </div>
            <!-- assign plan header -->
          </template>
        </template>

      </div>
    </div>

	    <div class="page_content_container" :class="isNotCustomAdmin ? '' : 'no_left_nav'">
	      	<institution-menu :uuid="uuid" :active="'paymentgateway'"></institution-menu>

          <div class="row pg_content">
			      <div class="col-12">
			          <b-jumbotron style="padding-top: 10px;">
                  <template v-if="!showLoader">
                    <template v-if="!showEditProgramAssignment && !showEditPricingPlanAssignment">
                      <template v-if="isPaymentGatewayEnabled">
                        <template v-if="paymentGateway.setupComplete">
                            <div class="">
                              <div class="mt-2" v-if="couponCodes.length > 0">
                                <div class="row plan_row" v-for="couponCode in couponCodes">
                                  <div class="col-12">

                                    <div class="row">

                                      <div class="col-4">

                                        <div class="row col_row">
                                          <div class="col-12 ace_sec_txt title">
                                            {{couponCode.name}}
                                          </div>
                                        </div>

                                        <div class="row col_row">
                                          <div class="col-12 ace_sec_txt" v-if="couponCode.type === 'flat'">
                                            Flat Discount
                                          </div>
                                          <div class="col-12 ace_sec_txt" v-if="couponCode.type === 'percentage'">
                                            Percentage % Discount
                                          </div>
                                        </div>

                                        <div class="row col_row">
                                          <div class="col-12 ace_sec_txt">Start Date: {{couponCode.startDate}}</div>
                                        </div>
                                        <div class="row col_row">
                                          <div class="col-12 ace_sec_txt">Expiration Date: {{couponCode.expirationDate}}</div>
                                        </div>

                                      </div>

                                      <div class="col-5">
                                        <div class="description">
                                          <div class="desc_txt" v-html="couponCode.description"></div>
                                        </div>
                                      </div>

                                      <div class="col-3 rgt_col">

                                        <div class="row col_row" v-if="couponCode.programs.length === 0 && couponCode.pricingPlans.length === 0 && couponCode.users.length === 0">
                                          <div class="col-12 action_sec">
                                            <a href="javascript://" class="ace_sec_txt" title="delete coupon" @click="showDeleteCouponCodeConfirm(couponCode)">
                                              <span class="ic ic22-bin"></span>
                                            </a>
                                          </div>
                                        </div>

                                        <div class="row col_row">
                                          <div class="col-12 ace_sec_txt"> {{couponCode.code}} - <span class="coupon_val"><span v-if="couponCode.type === 'flat'"> $</span>{{couponCode.value}}<span v-if="couponCode.type === 'percentage'">%</span></span></div>
                                        </div>

                                        <div class="row col_row" v-if="couponCode.active">
                                          <div class="col-12 ace_sec_txt">
                                            <span class="label">Coupon active</span>
                                            <a href="javascript://" class="btn active" @click="deactiveCoupon(couponCode)">
                                              <span class="lbl_ic"></span>
                                              <span class="lbl_txt">yes</span>
                                            </a>
                                          </div>
                                        </div>

                                        <div class="row col_row" v-if="!couponCode.active">
                                          <div class="col-12 ace_sec_txt">
                                            <span class="label">Coupon active</span>
                                            <a href="javascript://" class="btn inactive" @click="activeCoupon(couponCode)">
                                              <span class="lbl_ic"></span>
                                              <span class="lbl_txt">no</span>
                                            </a>
                                          </div>
                                        </div>

                                        <div class="row col_row">
                                          <div class="col-12 lnk_container">
                                            <a href="javascript://" @click="updateProgramGuideAssignment(couponCode)">assign coupon to programs</a>
                                          </div>
                                        </div>
                                        <div class="row col_row">
                                          <div class="col-12 lnk_container">
                                            <a href="javascript://" @click="updatePricingPlanAssignment(couponCode)">assign coupon to pricing plans</a>
                                          </div>
                                        </div>
                                        <!--
                                        <div class="row">
                                          <div class="col-12 text-center lnk_container">
                                            <a @click="updateProgramGuideAssignment(couponCode)">assign coupon to users</a>
                                          </div>
                                        </div>
                                        -->
                                      </div>

                                    </div>

                                    <div class="row assigned_row">
                                      <div class="col-2 ace_sec_txt label">
                                        Programs:
                                      </div>
                                      <div class="col-10 programs_list">
                                        <template v-if="couponCode.programGuideObjects.length > 0">
                                           <span class="program" v-for="pg in couponCode.programGuideObjects">{{pg.title}}</span>
                                        </template>
                                        <template  v-if="couponCode.programGuideObjects.length === 0">
                                          <span class="sec_info">No Program Assigned Yet</span>
                                        </template>
                                      </div>
                                    </div>
                                    <div class="row assigned_row">
                                      <div class="col-2 ace_sec_txt label">
                                        Plans:
                                      </div>
                                      <div class="col-10 programs_list">
                                        <template v-if="couponCode.pricingPlanObjects.length > 0">
                                          <span class="program" v-for="pP in couponCode.pricingPlanObjects">{{pP.name}}</span>
                                        </template>
                                        <template v-if="couponCode.pricingPlanObjects.length === 0">
                                          <span class="sec_info">No Pricing Plans Assigned Yet</span>
                                        </template>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>

                              <p class="text-center ace_sec_txt" v-if="couponCodes.length === 0">No coupons exist. Create one by clicking on add coupon.</p>
                            </div>

                        </template>
                      </template>
                      <template v-if="!isPaymentGatewayEnabled">
                        <h4 class="text-center ace_sec_txt">Please reach out to support@pragyasystems.com to enable this feature.</h4>
                      </template>
                    </template>
                    <template v-if="showEditProgramAssignment">
                      <div class="assign_plan">

                        <div class="row filter_bar">
                          <div class="col-6 select_all">
                            <input type="checkbox" v-model="selectAllProgramGuides" @change="selectUnselectAllProgramGuides($event)">
                            <label>All Programs</label>
                          </div>
                          <div class="col-6 btn_container">
                            <div class="srh_bx">
                              <input v-model="searchQuery" placeholder="Search for programs" class="">
                              <span class="ic ic22-search"></span>
                            </div>
                          </div>
                        </div>

                        <!--
                        <div class="mt-4">
                          <multiselect v-model="selectedProgramGuides" :options="programGuides" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select Program Guide" label="title" track-by="uuid" style="width: 96%;">
                          </multiselect>
                        </div>
                        -->
                        <div class="row programs_list">
                          <div class="col-12">

                            <div class="row">
                              <div class="col-12 program" v-for="pg in programGuides">
                                <input type="checkbox" :id="pg.uuid" :value="pg.code" v-model="selectedCouponCode.programs">
                                <label :for="pg.uuid">{{pg.title}}</label>
                              </div>
                            </div>

                          </div>
                        </div>

                      </div>

                    </template>
                    <template v-if="showEditPricingPlanAssignment">
                      <div class="assign_plan">

                        <div class="row filter_bar">
                          <div class="col-6 select_all">
                            <input type="checkbox" v-model="selectAllPricingPlans" @change="selectUnselectAllPricingPlans($event)">
                            <label>All PricingPlans</label>
                          </div>
                          <div class="col-6 btn_container">
                            <!--
                            <div class="srh_bx">
                              <input v-model="searchQueryPricingPlans" placeholder="Search for pricing plans" class="">
                              <span class="ic ic22-search"></span>
                            </div>
                            -->
                          </div>
                        </div>

                        <!--
                        <div class="mt-4">
                          <multiselect v-model="selectedProgramGuides" :options="programGuides" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select Program Guide" label="title" track-by="uuid" style="width: 96%;">
                          </multiselect>
                        </div>
                        -->
                        <div class="row programs_list">
                          <div class="col-12">

                            <div class="row">
                              <div class="col-12 program" v-for="pP in pricingPlans">
                                <input type="checkbox" :id="pP.uuid" :value="pP.uuid" v-model="selectedCouponCode.pricingPlans">
                                <label :for="pP.uuid">{{pP.name}}</label>
                              </div>
                            </div>

                          </div>
                        </div>

                      </div>

                    </template>
                  </template>
                  <template v-if="showLoader">
                    <p class="text-center ace_sec_txt">Loading..</p>
                  </template>
			          </b-jumbotron>
			      </div>
		      </div>
	    </div>
      <!-- New Coupon Code Modal -->
      <div>
        <b-modal class="modal__v22_2 price_plan_modal add_plan_modal" id="new-pricing-plan-modal-popup" ref="newCouponCodeModal" :header-bg-variant="'subscribe-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>

          <div slot="modal-header" class="w-100">
  					<div class="row">

  	          <div class="col-3 hd">
  							<div class="ic_container">
  								<span class="ic ic22-buy"></span>
  							</div>
  						</div>
              <div class="col-6 hd">
  							<div class="hd_txt txt_center">
  		            <span>Add a Coupon Code</span>
                </div>
  						</div>
  						<div class="col-3 btn_container">

                <a class="btn" @click="addNewCouponCode()">save</a>

  							<button class="btn_close" aria-label="close" title="close the popup" @click="closeNewCouponCodeModal">
  	              <span class="ic-close"></span>
  	            </button>
  						</div>
  					</div>
  				</div>

          <div class="row content_container">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 form_section">

              <p v-if="showCouponCodeCreationError" class="text-red">{{coupondCodeErrorMessage}}</p>

              <div class="row price_plan_sec">
                <div class="col-12 sec_content">

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="name">Name *</label>
                    </div>
                    <div class="col-12 fld_input">
                      <input v-model="newCouponCode.name">
                    </div>
                  </div>

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">Code*</label>
                    </div>
                    <div class="col-12 fld_input">
                      <input v-model="newCouponCode.code">
                      <a @click="generateCouponCode()" class="link">Generate Code</a>. Please enter a name before generating code.
                    </div>
                  </div>

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">Limit (# of times it can be used; -1 if unlimited)*</label>
                    </div>
                    <div class="col-12 fld_input">
                      <input v-model="newCouponCode.limit" type="number">
                    </div>
                  </div>

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">Type*</label>
                    </div>
                    <div class="col-12 fld_input">
                      <select v-model="newCouponCode.type">
                        <option value="flat">Flat Discount (X dollars off)</option>
                        <option value="percentage">Percent Discount(X% of original price off)</option>
                      </select>
                    </div>
                  </div>

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">Discount Value*</label>
                    </div>
                    <div class="col-12 fld_input">
                      <input v-model="newCouponCode.value" type="number">
                    </div>
                  </div>

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">Start Date*</label>
                    </div>
                    <div class="col-12 fld_input">
                      <datepicker id="startDate" v-model="newCouponCode.startDate" name="startDate" :disabledDates="disabledDates"></datepicker>
                    </div>
                  </div>

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">Expiration Date*</label>
                    </div>
                    <div class="col-12 fld_input">
                      <datepicker id="startDate" v-model="newCouponCode.expirationDate" name="expirationDate" :disabledDates="disabledDates"></datepicker>

                    </div>
                  </div>

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">Active*</label>
                    </div>
                    <div class="col-12 fld_input">
                      <select v-model="newCouponCode.active">
                        <option value="false">Inactive</option>
                        <option value="true">Active</option>
                      </select>
                    </div>
                  </div>

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">Description</label>
                    </div>
                    <div class="col-12 fld_input">
                      <div class="description_bx">
                        <editor api-key="no-api-key"
                          v-model="newCouponCode.description"
                          :init="{
                            base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                            menubar: false,
                            plugins: plugins,
                            toolbar: toolbar,
                            branding: false,
                            statusbar: false
                          }">
                        </editor>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>

        </b-modal>
      </div>
      <!-- New Coupon Code Modal Ends -->

      <!-- Delete Pricing Plan Modal -->
      <div>
          <b-modal class="delete-folder-popup" ref="deleteCouponCodeModal" :title="'Please Confirm!'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
              <div>
                  <span>Are you sure you would like to delete this Coupon?</span>
              </div>
            <div slot="modal-header" class="popover-header">
              <div class="popup-heading">Please Confirm!</div>
              <button class="btn_close" aria-label="close" @click="hideDeleteConfirmBox">
                  <span class="ic-close"></span>
              </button>
            </div>
            <div slot="modal-footer" class="w-100">
                <b-button @click="deleteCouponCode" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
                <b-button @click="hideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
            </div>
          </b-modal>
      </div>
      <!-- Delete Pricing Plan Ends -->
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'
import { PACKAGE } from '../../../package_constants'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Editor from '@tinymce/tinymce-vue'
import Datepicker from 'vuejs-datepicker'

var DisableDate = function (startDate) {
  const date = (startDate) ? new Date(startDate) : new Date()
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export default {
  name: 'institutionCouponCodes',
  props: ['uuid'],
  components: {
    InstitutionMenu,
    InstitutionHeader,
    Editor,
    Datepicker
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole'),
      paymentGateway: {},
      stripeConnectLink: "",
      showLoader: false,
      couponCodes: [],
      isStripeConnected: true,
      newCouponCode: {
        name: '',
        description: '',
        code: '',
        limit: -1,
        startDate: '',
        expirationDate: '',
        value: 0,
        type: 'flat',
        active: true
      },
      showCouponCodeCreationError: false,
      coupondCodeErrorMessage: '',
      showEditProgramAssignment: false,
      showEditPricingPlanAssignment: false,
      selectedCouponCode: {},
      selectedProgramGuides: [],
      programGuides: [],
      pricingPlans: [],
      searchQuery: '',
      searchQueryPricingPlans: '',
      selectAllProgramGuides: false,
      selectAllPricingPlans: false,
      couponCodeToBeDeleted: {},
      plugins: 'lists  autolink charmap code hr link textcolor',
      toolbar: 'bold italic strikethrough | bullist numlist | indent outdent | alignleft aligncenter alignright | forecolor backcolor | removeformat link unlink',
      disabledDates: {
        to: new DisableDate()
      },
    }
  },
  mounted () {
    this.loadInstitution()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'loadUserAdvisor',
      'loadLogDashboardActivity',
      'loadInstitutionPaymentGateway',
      'loadStripeConnectUrl',
      'loadProgramGuides',
      'loadInstitutionCouponCodes',
      'loadCreateInstitutionCouponCode',
      'loadDeleteInstitutionCouponCode',
      'loadSaveInstitutionCouponCode',
      'loadInstitutionPricingPlans'
    ]),
    returnToEcommerce () {
      return this.$router.push({ name: 'institutionPaymentGateway', params: { uuid: this.uuid } })
    },
    async loadInstitution () {
      this.showLoader = true
      await this.loadLogDashboardActivity({action: 'viewInstitutionSummaryView', page: 'institutionSummaryView', link: '', entityUuid: this.uuid})
      await this.loadInstitutionDetail(this.uuid)
      this.paymentGateway = await this.loadInstitutionPaymentGateway()
      if (!this.paymentGateway.setupComplete) {
        this.stripeConnectLink = await this.loadStripeConnectUrl()
      }
      if (this.paymentGateway.setupComplete) {
        // load coupon codes
        this.couponCodes = await this.loadInstitutionCouponCodes()
        this.loadProgramGuides({page: 0, count: 100000, title: ''}).then(result => {
          this.programGuides = result.content
        })
        // load users
        // load pricing plans
        this.pricingPlans = await this.loadInstitutionPricingPlans()
      }
      this.showLoader = false
    },
    updateProgramGuideResults () {
      this.loadProgramGuides({page: 0, count: 100000, title: this.searchQuery}).then(result => {
        this.programGuides = result.content
      })
    },
    showDeleteCouponCodeConfirm (couponCode) {
      this.couponCodeToBeDeleted = couponCode
      this.$refs.deleteCouponCodeModal.show()
    },
    hideDeleteConfirmBox () {
      this.couponCodeToBeDeleted = {}
      this.$refs.deleteCouponCodeModal.hide()
    },
    async deleteCouponCode() {
      this.showLoader = true
      await this.loadDeleteInstitutionCouponCode(this.couponCodeToBeDeleted.uuid)
      this.hideDeleteConfirmBox()
      this.couponCodes = await this.loadInstitutionCouponCodes()
      this.showLoader = false
    },
    openNewCouponCodeModal () {
      this.$refs.newCouponCodeModal.show()
    },
    closeNewCouponCodeModal () {
      this.newCouponCode = {
        name: '',
        description: '',
        code: '',
        limit: -1,
        startDate: '',
        expirationDate: '',
        value: 0,
        type: 'flat'
      }
      this.$refs.newCouponCodeModal.hide()
    },
    async addNewCouponCode() {
      this.showCouponCodeCreationError = false
      this.coupondCodeErrorMessage = ''
      if (this.newCouponCode.name.length > 0 && this.newCouponCode.code.length > 0
        && this.newCouponCode.limit > -2 && this.newCouponCode.startDate && this.newCouponCode.expirationDate
        && this.newCouponCode.value > 0 && this.newCouponCode.type.length > 0
      ) {
        if (this.newCouponCode.type === 'percentage' && this.newCouponCode.value > 100) {
          this.showCouponCodeCreationError = true
          this.coupondCodeErrorMessage = 'Percentage Discount cannot exceed 100.'
        } else {
          let startDate = new Date(this.newCouponCode.startDate)
          let expirationDate = new Date(this.newCouponCode.expirationDate)
          if (startDate > expirationDate) {
            this.showCouponCodeCreationError = true
            this.coupondCodeErrorMessage = 'Start Date must be before the expiration date'
          } else {
            this.showLoader = true
            await this.loadCreateInstitutionCouponCode(this.newCouponCode)
            this.couponCodes = await this.loadInstitutionCouponCodes()
            this.closeNewCouponCodeModal()
            this.showLoader = false
          }
        }
      } else {
        this.showCouponCodeCreationError = true
        this.coupondCodeErrorMessage = 'Please be sure to fill out all the required fields.'
      }
    },
    generateCouponCode () {
      if (this.newCouponCode.name.length > 0) {
        let generatedACode = false
        let code = this.newCouponCode.name.replace(/\s/g, "")
        code = code.toUpperCase()
        let isExists = false
        while (!generatedACode) {
          // check if code exists
          isExists = false
          this.couponCodes.forEach((item, i) => {
            if (item.code === code) {
              isExists = true
            }
          })

          if (isExists) {
            code = code + '2'
          } else {
            generatedACode = true
          }
        }

        this.newCouponCode.code = code
      }
    },
    updateProgramGuideAssignment (couponCode) {
      this.selectedCouponCode = couponCode
      this.showEditProgramAssignment = true

      if (this.selectedCouponCode.programs.length === this.programGuides.length) {
        this.selectAllProgramGuides = true
      } else {
        this.selectAllProgramGuides = false
      }
    },
    updatePricingPlanAssignment (couponCode) {
      this.selectedCouponCode = couponCode
      this.showEditPricingPlanAssignment = true

      if (this.selectedCouponCode.pricingPlans.length === this.pricingPlans.length) {
        this.selectAllPricingPlans = true
      } else {
        this.selectAllPricingPlans = false
      }
    },
    async saveUpdateAssignment () {
      this.showLoader = true
      this.selectedCouponCode.programGuideObjects = []
      this.selectedCouponCode.pricingPlanObjects = []
      this.selectedCouponCode.userObjects = []
      await this.loadSaveInstitutionCouponCode({couponCodeId: this.selectedCouponCode.uuid, couponCodeObj: this.selectedCouponCode})
      this.couponCodes = await this.loadInstitutionCouponCodes()
      this.showEditProgramAssignment = false
      this.showEditPricingPlanAssignment = false
      this.selectedCouponCode = {}
      this.showLoader = false
    },
    async deactiveCoupon (couponCode) {
      this.showLoader = true
      couponCode.active = false
      couponCode.programGuideObjects = []
      couponCode.pricingPlanObjects = []
      couponCode.userObjects = []
      await this.loadSaveInstitutionCouponCode({couponCodeId: couponCode.uuid, couponCodeObj: couponCode})
      this.couponCodes = await this.loadInstitutionCouponCodes()
      this.showLoader = false
    },
    async activeCoupon (couponCode) {
      this.showLoader = true
      couponCode.active = true
      couponCode.programGuideObjects = []
      couponCode.pricingPlanObjects = []
      couponCode.userObjects = []
      await this.loadSaveInstitutionCouponCode({couponCodeId: couponCode.uuid, couponCodeObj: couponCode})
      this.couponCodes = await this.loadInstitutionCouponCodes()
      this.showLoader = false
    },
    async selectUnselectAllProgramGuides (e) {
      if (e.target.checked) {
        // select all programs
        this.programGuides.forEach((item, i) => {
          if (this.selectedCouponCode.programs.indexOf(item.code) === -1) {
            this.selectedCouponCode.programs.push(item.code)
          }
        })
      } else {
        // unselect all selected programs and call delete
        this.selectedCouponCode.programs = []
      }
    },
    selectUnselectAllPricingPlans (e) {
      if (e.target.checked) {
        // select all programs
        this.pricingPlans.forEach((item, i) => {
          if (this.selectedCouponCode.pricingPlans.indexOf(item.uuid) === -1) {
            this.selectedCouponCode.pricingPlans.push(item.uuid)
          }
        })
      } else {
        // unselect all selected programs and call delete
        this.selectedCouponCode.pricingPlans = []
      }
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures,
    }),
    isPaymentGatewayEnabled () {
      let paymentGateway = this.enabledFeatures[PACKAGE.FEATURE_IDS.PAYMENT_INTEGRATION]
      if (paymentGateway) {
        return paymentGateway.enabled
      }
      return false
    },
    isNotCustomAdmin () {
      let currentUser = JSON.parse(localStorage.getItem('userobj'))
      return !(currentUser && currentUser.customAdmin)
    }
  },
  watch: {
    searchQuery (newSearchQuery) {
      this.updateProgramGuideResults()
    },
    searchQueryPricingPlans (newSearchQueryPricingPlans) {
      // filter pricingPlan results
    }
  }
}
</script>
<style>
.text-green {
  color: green;
}

.text-red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionCouponCodes.vue